import { render } from "./AnnotationCanvas.vue?vue&type=template&id=56768adc&scoped=true"
import script from "./AnnotationCanvas.vue?vue&type=script&lang=js"
export * from "./AnnotationCanvas.vue?vue&type=script&lang=js"

import "./AnnotationCanvas.vue?vue&type=style&index=0&id=56768adc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56768adc"]])

export default __exports__